export default __webpack_public_path__ + "static/media/rules.f913cfac.svg";